import moment from 'moment-timezone';
import { environment } from 'environments';

(() => {
  class VisitListController {
    constructor() {
      this.ENV = ['localhost'];
      this.BOD_855_feature_flag = this.ENV.includes(environment.constants.ENV);
      this.BOD_1857 = ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV);
      this.BOD_1780 = ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV);
      this.BOD_1857 = ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV);
      this.BOD_1780 = ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV);
    }
    formatDate(iso_date) {
      if (!iso_date) return null;
      const formatted_date = moment.tz(iso_date, this.timezone).format('DD/MMM/YY h:mm A');
      return formatted_date;
    }
  }

  angular.module('pims').component('visitTable', {
    templateUrl: 'app/components/visit-table/visit-table.html',
    controller: VisitListController,
    bindings: {
      savePageLocalStorageKey: '=',
      pagination: '=',
      sortBy: '=',
      sortOrder: '=',
      onPageChange: '&',
      onSort: '&',
      visits: '<',
      profile: '<',
      timezone: '=',
    },
  });
})();
